<template>
  <HStack gap="1">
    <Star :width="size" :height="size" />
    <Star :width="size" :height="size" />
    <Star :width="size" :height="size" />
    <Star :width="size" :height="size" />
    <Star :width="size" :height="size" />
  </HStack>
</template>
<script>
import HStack from "@/Layout/Stack/HStack";
import Star from "../Reviews/assets/star.svg?inline";

export default {
  name: "RowOfStars",
  components: { HStack, Star },
  props: {
    size: {
      type: Number,
      required: false,
      default: 22,
    },
  },
};
</script>
